import { UserContext, config, MemberQuery } from '@fgb/core';

/**
 * Builds the same ContentAssets CDN URL as the library's contentAssetImage pipe.
 * Used outside of templates (pipes/directives/services) where the pipe can't be applied directly,
 * since ContentAssetImagePipe itself isn't registered as an injectable provider.
 */
export function buildContentAssetUrl(memberQuery: MemberQuery, value: string): string {
  if (!value) {
    return `${config.contentUrl}/noimage.png`;
  }

  if (value.includes('http')) {
    return value;
  }

  const currentUser = memberQuery.getValue().user || ({ clubId: config.defaultClubId, lcid: config.defaultLcid } as UserContext);

  return `${config.contentUrl}/assets/${currentUser.clubId}/${currentUser.lcid}/${value}`;
}
